export function redondearA10(numero) {
    let ultimosDigitos = numero % 10;
    let redondeado = numero - ultimosDigitos;
    if (ultimosDigitos >= 5) {
        redondeado += 10;
    }
    return redondeado;
}